/**
 * tdesign v0.44.2
 * (c) 2022 tdesign
 * @license MIT
 */

import Dialog$1 from './Dialog.js';
import { DialogPlugin as DialogPlugin$1 } from './plugin.js';
import './style/index.js';
import './type.js';
import '../_chunks/dep-5e9bbb71.js';
import '../_chunks/dep-784849f3.js';
import '../_chunks/dep-d6cc3db8.js';
import '../_chunks/dep-74ef9ead.js';
import 'react';
import '../_chunks/dep-10140b37.js';
import '../_chunks/dep-7a9656a6.js';
import '../_chunks/dep-da112583.js';
import '../_chunks/dep-dfae10c3.js';
import '../_chunks/dep-1792ab93.js';
import '../_chunks/dep-1e4c771d.js';
import '../_chunks/dep-f4495ac9.js';
import '../_chunks/dep-670cc86e.js';
import '../_chunks/dep-6c09308a.js';
import 'tdesign-icons-react';
import '../locale/LocalReceiver.js';
import '../config-provider/index.js';
import '../config-provider/ConfigProvider.js';
import '../_chunks/dep-5eadc4f3.js';
import '../_chunks/dep-fd215ab0.js';
import '../_chunks/dep-8127363b.js';
import '../_chunks/dep-a0b71ae4.js';
import '../_chunks/dep-4ca52001.js';
import '../_chunks/dep-408df89a.js';
import '../_chunks/dep-e755a9cb.js';
import '../_chunks/dep-15d0e734.js';
import '../_chunks/dep-b0c02324.js';
import '../_chunks/dep-a09b6dac.js';
import '../_chunks/dep-9c2f4c72.js';
import '../_chunks/dep-da7344ec.js';
import '../_chunks/dep-01fe0fd1.js';
import '../_chunks/dep-20a8e46d.js';
import '../_chunks/dep-9d067299.js';
import '../config-provider/ConfigContext.js';
import '../locale/zh_CN.js';
import '../_common/js/global-config/locale/zh_CN.js';
import '../_common/js/global-config/default-config.js';
import '../button/index.js';
import '../button/Button.js';
import 'classnames';
import '../hooks/useConfig.js';
import '../hooks/useDomRefCallback.js';
import '../_util/useRipple.js';
import '../_util/useAnimation.js';
import '../_util/setStyle.js';
import '../_util/dom.js';
import 'raf';
import '../_util/easing.js';
import '../loading/index.js';
import '../loading/Loading.js';
import '../common/Portal.js';
import 'react-dom';
import '../loading/gradient.js';
import '../_common/js/loading/circle-adapter.js';
import '../_common/js/utils/set-style.js';
import '../_common/js/utils/helper.js';
import '../_chunks/dep-0508545e.js';
import '../loading/defaultProps.js';
import '../loading/plugin.js';
import '../_util/react-render.js';
import '../_chunks/dep-d07435ee.js';
import '../loading/style/index.js';
import '../loading/type.js';
import '../button/defaultProps.js';
import '../_util/parseTNode.js';
import '../button/style/index.js';
import '../button/type.js';
import '../_util/noop.js';
import './RenderDialog.js';
import 'react-transition-group';
import '../_util/useDialogEsc.js';
import './defaultProps.js';
import './hooks/useLockStyle.js';
import '../_util/useLayoutEffect.js';
import '../_common/js/utils/getScrollbarWidth.js';
import '../_util/useSetState.js';
import '../hooks/useGlobalIcon.js';
import '../_common/js/log/index.js';
import '../_common/js/log/log.js';

var Dialog = Dialog$1;
var dialog = DialogPlugin$1;
var DialogPlugin = DialogPlugin$1;

export { Dialog, DialogPlugin, Dialog as default, dialog };
//# sourceMappingURL=index.js.map
